import { createFileRoute } from '@tanstack/react-router';
import { FxPage } from '../../features/catalogue';

export const Route = createFileRoute('/portal/catalogue/fx')({ component: FxPage });
